// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"718":"ea210a87","949":"ce46fe4e"}[chunkId] + ".chunk.css";
};